<template>
  <div class="wrapper">
    <div class="section page-header" :style="headerStyle">
      <div class="container"></div>
    </div>
    <div class="main">
      <div class="large-section">
        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">{{ $t("sfdw.intro.title") }}</h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("sfdw.intro.description1") }}
                  <br /><br />
                  {{ $t("sfdw.intro.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="project" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("sfdw.framework.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("sfdw.framework.description") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="framework" preview="0" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("sfdw.aesthetic.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("sfdw.aesthetic.description") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="aesthetic" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("sfdw.experience.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("sfdw.experience.description") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="experience" preview="0" />
              </div>
            </div>

            <div class="md-layout section-internal-padding">
              <div class="container">
                <div class="video-wrapper">
                  <img
                    class="video-image-ratio"
                    src="@/assets/img/common/video_placeholder.png"
                  />
                  <iframe
                    height="498"
                    width="510"
                    src="https://www.youtube.com/embed/5jmzs2DQ-wg?si=rNM06NIxuVR2xMR3"
                    frameborder="0"
                    allowfullscreen="true"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- main-->
  </div>
  <!-- wrapper-->
</template>

<script>
export default {
  bodyClass: "sdfw-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/sfdw/background.png")
    },
    project: {
      type: String,
      default: require("@/assets/img/sfdw/project.png")
    },
    framework: {
      type: String,
      default: require("@/assets/img/sfdw/framework.png")
    },
    aesthetic: {
      type: String,
      default: require("@/assets/img/sfdw/aesthetic.png")
    },
    experience: {
      type: String,
      default: require("@/assets/img/sfdw/experience.png")
    },
    video_placeholder: {
      type: String,
      default: require("@/assets/img/common/video_placeholder.png")
    }
  },
  data() {
    return {
      isMobileDevice: this.$isMobile
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
        backgroundSize: `cover`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.text-on-image-centered {
  position: absolute;
  padding: 23% 20%;
  //   font-size: 36px;
  //   line-height: 48px;
  //   font-weight: 700;
  //   color: white;
  //   text-align: center;
  //   text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);
}
</style>
